import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { apiFunction } from "../utils/API";

const getCategoryIcon = (name = "") => {
  const n = name.toLowerCase();
  const s = (path) => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#034EA2" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {path}
    </svg>
  );
  if (n.includes("transistor"))
    return s(<><line x1="5" y1="12" x2="11" y2="12"/><line x1="11" y1="6" x2="11" y2="18"/><line x1="11" y1="8" x2="19" y2="4"/><line x1="11" y1="16" x2="19" y2="20"/><circle cx="19" cy="4" r="1" fill="#034EA2"/><circle cx="19" cy="20" r="1" fill="#034EA2"/></>);
  if (n.includes("diode") || n.includes("rectif") || n.includes("tvs") || n.includes("zener"))
    return s(<><line x1="3" y1="12" x2="21" y2="12"/><polygon points="8,7 8,17 16,12" fill="rgba(34,80,138,0.15)" stroke="#034EA2"/><line x1="16" y1="7" x2="16" y2="17"/></>);
  if (n.includes("mosfet") || n.includes("igbt"))
    return s(<><rect x="10" y="4" width="2" height="16" rx="1"/><line x1="6" y1="8" x2="10" y2="8"/><line x1="6" y1="12" x2="10" y2="12"/><line x1="6" y1="16" x2="10" y2="16"/><line x1="3" y1="8" x2="6" y2="8"/><line x1="3" y1="16" x2="6" y2="16"/><line x1="12" y1="12" x2="21" y2="12"/></>);
  if (n.includes("thyristor") || n.includes("scr") || n.includes("triac"))
    return s(<><line x1="3" y1="12" x2="21" y2="12"/><polygon points="8,7 8,17 16,12" fill="rgba(34,80,138,0.15)" stroke="#034EA2"/><line x1="16" y1="7" x2="16" y2="17"/><line x1="12" y1="17" x2="12" y2="21"/></>);
  return s(<><rect x="6" y="6" width="12" height="12" rx="1"/><line x1="6" y1="9" x2="3" y2="9"/><line x1="6" y1="12" x2="3" y2="12"/><line x1="6" y1="15" x2="3" y2="15"/><line x1="18" y1="9" x2="21" y2="9"/><line x1="18" y1="12" x2="21" y2="12"/><line x1="18" y1="15" x2="21" y2="15"/><line x1="9" y1="6" x2="9" y2="3"/><line x1="15" y1="6" x2="15" y2="3"/><line x1="9" y1="18" x2="9" y2="21"/><line x1="15" y1="18" x2="15" y2="21"/></>);
};



const ViewByType = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  const [fetchData, setFetchData] = useState([]);
  const [subMap, setSubMap] = useState({}); // categoryId → subcategories

  /* ================= VALIDATE & LOAD MAIN DATA ================= */
  useEffect(() => {
    if (!["industry", "category"].includes(type)) {
      navigate("/");
      return;
    }

    const getData = async () => {
      if (type === "industry") {
        await apiFunction({
          method: "GET",
          endpoint: "frontend/industry/all",
          setData: setFetchData,
        });
      } else {
        await apiFunction({
          method: "GET",
          endpoint: "frontend/category/all",
          setData: setFetchData,
        });
      }
    };

    getData();
  }, [type, navigate]);

  /* ================= FETCH SUBCATEGORIES (FIXED) ================= */
  useEffect(() => {
    if (type !== "category" || fetchData.length === 0) return;

    fetchData.forEach((cat) => {
      apiFunction({
        method: "GET",
        endpoint: `frontend/subcategory?apiParams[page]=0&apiParams[searchParams]=&categoryId=${cat.categoryId}`,
        setData: (data) => {
          // ✅ FIX: API returns OBJECT, convert to ARRAY
          const subcategories = Array.isArray(data)
            ? data
            : Object.values(data || {});

          setSubMap((prev) => ({
            ...prev,
            [cat.categoryId]: subcategories,
          }));
        },
      });
    });
  }, [fetchData, type]);

  return (

    <section className="product-categories page-section" >
       

      <div className="container" style={{ paddingTop: "6rem" }}>
        {/* HEADER */}
        <div className="pc-header">
          <h2>
            {type === "industry" ? "INDUSTRIES" : "PRODUCT CATEGORIES"}
          </h2>
          
        </div>

        {/* GRID */}
        <div className="pc-grid">
          {fetchData.length > 0 ? (
            fetchData.map((item, index) => (
              <div className="pc-card" key={index}>
                <div style={{ marginBottom: "12px" }}>{getCategoryIcon(type === "industry" ? item : item.categoryName)}</div>
                {/* BADGE */}
               <Link to={`/table/category/${item.categoryName}/all`}>
                 <span className="pc-badge">
                   {type === "category"
                     ? (subMap[item.categoryId]?.length || 0) + " Subcategories"
                     : "View Products"}
                 </span>
               </Link>

                {/* TITLE */}
                <h3 style={{ fontSize: "14px" }}>{type === "industry" ? item : item.categoryName}</h3>

                {/* SUBCATEGORY LIST */}
                {type === "category" && (
                  <ul>
                    {(subMap[item.categoryId] || [])
                      .slice(0, 3)
                      .map((sub, i) => (
                        <li key={i}>
                          <Link
                            to={`/table/category/${item.categoryName}/${sub.subcatName}`}
                          >
                            {sub.subcatName} <b style={{ float: "right" }}>→</b>
                          </Link>
                        </li>
                      ))}   
                  </ul>
                )}

                {/* INDUSTRY LINK */}
                {type === "industry" && (
                  <Link
                    to={`/table/category/all/all?industry=${item}`}
                    className="industry-link"
                  >
                    View Products →
                  </Link>
                )}
              </div>
            ))
          ) : (
            <p>No data available</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default ViewByType;
